import {ReactNode} from "react";

export default function Card({children, className}: {children: ReactNode; className?: string, key?: string|number}) {
    return (
        <div className={`card ${className}`}>
            {children}
        </div>
    );
}